import React, { useRef } from 'react';
import { FiUpload, FiTrash2, FiFileText } from 'react-icons/fi';

const FILE_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
];

const FileUpload = ({ files, setFiles }) => {
  const inputRef = useRef();

  const handleFiles = (fileList) => {
    let arr = Array.from(fileList);
    // Filtrer les types et la limite
    arr = arr.filter(f => FILE_TYPES.includes(f.type));
    if (files.length + arr.length > 3) arr = arr.slice(0, 3 - files.length);
    setFiles([...files, ...arr]);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    handleFiles(e.dataTransfer.files);
  };

  const handleRemove = (idx) => {
    setFiles(files.filter((_, i) => i !== idx));
  };

  return (
    <div>
      <label className="block text-sm font-medium mb-1">Pièces jointes (max 3, PDF/Word/Excel)</label>
      <div
        className="border-2 border-dashed border-gray-300 rounded p-4 text-center cursor-pointer bg-gray-50 hover:bg-gray-100"
        onClick={() => inputRef.current.click()}
        onDrop={handleDrop}
        onDragOver={e => e.preventDefault()}
      >
        <FiUpload className="inline mr-2" />
        Glissez-déposez ou cliquez pour sélectionner des fichiers
        <input
          ref={inputRef}
          type="file"
          multiple
          accept=".pdf,.doc,.docx,.xls,.xlsx"
          className="hidden"
          onChange={e => handleFiles(e.target.files)}
          disabled={files.length >= 3}
        />
      </div>
      <div className="mt-2 space-y-2">
        {files.map((file, idx) => (
          <div key={idx} className="flex items-center justify-between bg-white border rounded px-3 py-2">
            <span className="flex items-center gap-2">
              <FiFileText />
              {file.name} ({(file.size / 1024).toFixed(1)} Ko)
            </span>
            <button
              type="button"
              className="text-red-600 hover:text-red-900"
              onClick={() => handleRemove(idx)}
              title="Supprimer"
            >
              <FiTrash2 />
            </button>
          </div>
        ))}
      </div>
      {files.length >= 3 && (
        <div className="text-xs text-red-500 mt-1">Vous ne pouvez sélectionner que 3 fichiers maximum.</div>
      )}
    </div>
  );
};

export default FileUpload;
